import { Link, NavLink } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import { navLinkBase } from "../../utils/styles";

export interface MenuItem {
  name: string;
  target?: "internal" | "external";
  href?: string;
  type?: "group" | "icon";
  children?: MenuItem[];
  img?: string;
}

interface MenuItemRendererProps {
  item: MenuItem;
  className?: string;
  onClick?: () => void;
}

export function MenuItemRenderer({ item, className = navLinkBase, onClick }: MenuItemRendererProps) {
  if (item.type === "icon") {
    return (
      <Link
        key={item.name}
        to={item.href!}
        className={className}
        onClick={onClick}
      >
        <img
          src={item.img}
          className="size-8 flex-none text-white/80 hover:text-white"
          aria-hidden="true"
          alt={item.name}
        />
        <span className="sr-only">{item.name}</span>
      </Link>
    );
  }

  if (item.target === "internal") {
    return (
      <NavLink
        key={item.name}
        to={item.href!}
        className={({ isActive }) => twMerge(className, isActive && 'text-white')}
        onClick={onClick}
      >
        {item.name}
      </NavLink>
    );
  }

  return (
    <Link
      key={item.name}
      to={item.href!}
      className={className}
      onClick={onClick}
    >
      {item.name}
    </Link>
  );
}